import React, { useState, useEffect } from "react";
import { AutoComplete } from "antd";
import { OptionType, SearchInBoardPropsType } from "../../type";
import { DefaultOptionType as Option } from "antd/es/select";

import styles from "../../style/index.module.scss";
import { SearchIcon } from "../../assets";
import classNames from "classnames";
// 扁平化 options 并生成完整路径的 label
const flattenOptionsWithPath = (options: Option[]): Option[] => {
  let result: OptionType[] = [];

  const flatten = (items: Option[], currentPath: string[], currentValue: (string | number)[]) => {
    let newResult = [];

    items.forEach((item) => {
      let currentLabel = typeof item.label === "string" ? item.label : item.originalLabel;

      const newPath = [...currentPath, currentLabel];

      const newValue = [...currentValue, item.value];

      const labelPath = newPath;
      let hasChildren = Boolean(item.children?.length);

      let newItem = {
        value: newValue,
        label: typeof item.label === "string" ? item.label : item.originalLabel,
        labelPath,
        level: newPath.length,
        isLasted: !hasChildren
      } as any;

      newResult.push(newItem);

      if (item.children) {
        newItem.children = flatten(item.children, newPath, newValue);
      }
    });

    return newResult;
  };

  result = flatten(options, [], []);
  //
  return result;
};

const highlightMatch = (text: string, searchValue: string) => {
  const regex = new RegExp(`(${searchValue})`, "gi");
  return text.replace(regex, (match) => `<span class=${styles.highlight}>${match}</span>`);
};

const SearchInBoard = ({
  options,
  setValue,
  searchBoardPlaceholder,
  searchValue,
  setSearchValue,
  onChange,
  onlySearchInLastedLayer,
  renderSearchEmpty
}: SearchInBoardPropsType) => {
  const [optionsAfterFilter, setOptions] = useState<Option[]>([]);
  const [flattenedOptions, setFlattenedOptions] = useState<Option[]>([]);
  console.log("optionsAfterFilter", optionsAfterFilter);

  useEffect(() => {
    setFlattenedOptions(flattenOptionsWithPath(options));
  }, [options]);
  console.log({ options });

  const appendAllChildren = (item, result = []) => {
    result.push(item); // Add the current item
    if (item.children) {
      item.children.forEach((child) => appendAllChildren(child, result));
    }
  };

  // 递归添加所有子节点（但不包括自身）
  const appendAllChildrenWithoutSelf = (item: any, output: any[] = []) => {
    if (item.children) {
      item.children.forEach((child: any) => {
        output.push(child); // 添加直接子节点
        if (child.children) {
          appendAllChildrenWithoutSelf(child, output); // 递归深层子节点
        }
      });
    }
  };

  const appendChild = (item: any, output: any[] = []) => {
    if (item.children) {
      item.children.forEach((child: any) => appendAllChildren(child, output)); // 添加所有子孙
    }
  };

  const handleSearch = (value: string) => {
    setSearchValue(value);
    let result: any[] = [];

    const forEachFilter = (filter: any[] = []) => {
      filter.forEach((item) => {
        const itemLabel = typeof item.label === "string" ? item.label : item.originalLabel;
        const isMatch = itemLabel?.toLowerCase()?.includes(value.toLowerCase());

        if (onlySearchInLastedLayer) {
          // 原有逻辑：仅在最后一层搜索
          if (!item.isLasted) {
            if (isMatch && item.children) {
              appendChild(item, result); // 匹配父节点时，添加所有子节点
            } else if (item.children) {
              forEachFilter(item.children); // 继续搜索子节点
            }
          } else if (isMatch) {
            result.push(item); // 最后一层的匹配项
          }
        } else {
          // 新逻辑：全局搜索，匹配父节点时仅携带子节点（不包含自身）
          if (isMatch) {
            if (item.level === 1) {
              appendAllChildrenWithoutSelf(item, result); // 第一级匹配时，仅添加所有子节点
            } else {
              result.push(item); // 其他层级正常添加
            }
          }
          // 无论是否匹配，继续搜索子节点（确保能搜到深层独立节点）
          if (item.children) {
            forEachFilter(item.children);
          }
        }
      });
    };

    forEachFilter(flattenedOptions);

    // 去重（防止子节点重复添加）
    const uniqueOptions = result.filter(
      (item, index, self) => index === self.findIndex((t) => t.value === item.value)
    );

    // 格式化结果
    const filteredOptions: Option[] = uniqueOptions.map((item) => ({
      ...item,
      value: item.value,
      currentLabel: typeof item.label === "string" ? item.label : item.originalLabel,
      title: item.labelPath.join(" / "),
      label: (
        <span
          dangerouslySetInnerHTML={{ __html: highlightMatch(item.labelPath.join(" / "), value) }}
        />
      )
    }));

    setOptions(filteredOptions.sort((a, b) => b.level - a.level));
  };
  const handleOnSelect = (data, option) => {
    let newOptions = (option.labelPath || []).map((label, index) => {
      return { label, value: data[index] };
    });
    onChange(data, newOptions);
    // setValue(data);
    setSearchValue(option.currentLabel);
  };

  return (
    <div className={styles.autoCompleteWrapper}>
      <AutoComplete
        options={
          Boolean(searchValue?.length)
            ? Boolean(optionsAfterFilter.length)
              ? optionsAfterFilter
              : renderSearchEmpty
              ? [{}]
              : null
            : []
        }
        virtual={false}
        onSearch={handleSearch}
        value={searchValue}
        placeholder={searchBoardPlaceholder || "Search"}
        getPopupContainer={(node) => node.parentElement}
        onSelect={handleOnSelect}
        className={classNames(styles.overrideAutoComplete, "custom-searchInBoard-autoComplete")}
        dropdownRender={(menu) => {
          return (
            <>
              {searchValue && searchValue.length
                ? optionsAfterFilter.length
                  ? menu
                  : renderSearchEmpty?.(searchValue) || null
                : null}
            </>
          );
        }}
        prefix={<SearchIcon />}
      />
    </div>
  );
};

export default SearchInBoard;
